import { motion } from "framer-motion";

export const MaskLinesInView = ({ lines, delay = 0, lineClass = "" }) => (
  <motion.span className="block" initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${lineClass}`}
          variants={{ hidden: { y: "105%" }, show: { y: 0 } }}
          transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1], delay: delay + i * 0.12 }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);
